import { Document } from '@contentful/rich-text-types'
import { Body, ContentfulRichText } from '@superhi/design'
import React from 'react'

import Hyperlink from '../Hyperlink'
import { LibraryPostBlockBase } from '../types'

import { Wrapper } from './styles'

export type LibraryPostBlockLetter = LibraryPostBlockBase<
  'blogPostLetter',
  {
    body: Document
  }
>

type Props = {
  children: Document
}

const LibraryPostBlockLetter: React.FC<Props> = ({ children }) => (
  <Wrapper>
    <ContentfulRichText
      nodeOverrides={{
        paragraph: (_, c) => <Body level="2">{c}</Body>,
        hyperlink: (_, c) => <Hyperlink url={_.data.uri}>{c}</Hyperlink>,
      }}
    >
      {JSON.stringify(children)}
    </ContentfulRichText>
  </Wrapper>
)

export default LibraryPostBlockLetter
